/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BetaFolder.vue?vue&type=template&id=b7e04714&scoped=true&"
import script from "./BetaFolder.vue?vue&type=script&lang=js&"
export * from "./BetaFolder.vue?vue&type=script&lang=js&"
import style0 from "./BetaFolder.vue?vue&type=style&index=0&id=b7e04714&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e04714",
  null
  
)

export default component.exports